import { render, staticRenderFns } from "./virtualAccountDetailsModal.vue?vue&type=template&id=7abb8499&scoped=true&"
import script from "./virtualAccountDetailsModal.vue?vue&type=script&lang=js&"
export * from "./virtualAccountDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./virtualAccountDetailsModal.vue?vue&type=style&index=0&id=7abb8499&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abb8499",
  null
  
)

export default component.exports